import { ImageEmbedProps } from '@stadionhq-v3/base-ui';
import {
  ContentfulImage,
  ContentfulImageProps,
} from '@stadionhq-v3/contentful-ui';
import { CleanedContentfulImageProps } from '@stadionhq-v3/clean-contentful';

const imageEmbedTransform = (
  data: CleanedContentfulImageProps
): ImageEmbedProps => ({
  image: <ContentfulImage {...(data as ContentfulImageProps)} />,
  caption: data.caption,
  attribution: data.attribution,
});

export default imageEmbedTransform;
